import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getSecurityFunctions } from '@pos-app/core-ui';

import { PIBEmailDetails, PIBEmailList } from '@pos-app/data/lib/models/email';
import { Observable, BehaviorSubject } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';

@Component({
    selector: 'app-product-info-bulletin-email',
    templateUrl: './product-info-bulletin.component.html',
    styleUrls: ['./product-info-bulletin.component.scss'],
    imports: [NgIf, CoreUiModule, AsyncPipe]
})
export class ProductInfoBulletinEmailComponent implements OnInit {
  @ViewChild('productInfoBulletinEmailDetailContent') productInfoBulletinEmailDetailContent: any;
  @Input() isExternalUser: boolean;
  @Input() isProgrammeUser: boolean;
  isShowRows: boolean = false;
  title: string = 'Latest ARB Product Bulletin';
  productInfoBulletinEmail: PIBEmailDetails;
  productInfoBulletinEmailList: PIBEmailList[] = [];
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }

  private _loadingDetailViewSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingDetailView$ = this._loadingDetailViewSubject.asObservable();
  get loadingDetailView(): boolean {
    return this._loadingDetailViewSubject.value;
  }
  set loadingDetailView(v: boolean) {
    this._loadingDetailViewSubject.next(v);
  }
  public securityFunctions$: Observable<string[]>;

  constructor(private apiService: ApiService, private coreUiStore: Store<CoreUiPartialState>) {}

  ngOnInit() {
    this.loading = true;
    this.apiService.fetchPIBEmailList().subscribe((data) => {
      this.productInfoBulletinEmailList = data.emailList || [];
      this.loading = false;
    });
    this.securityFunctions$ = this.coreUiStore.select(getSecurityFunctions);
  }

  showProductInfoBulletinEmailDetail(pibEmail) {
    this.loadingDetailView = true;
    this.apiService.fetchPIBEmailDetails({ subject: pibEmail.subject, communicationGroup: pibEmail.communicationGroup }).subscribe((data) => {
      this.productInfoBulletinEmail = data.email;
      this.loadingDetailView = false;
    });
  }

  updateProductInfoBulletinEmailList(value: boolean) {
    if (value) {
      this.loading = true;
      this.apiService.fetchPIBEmailList().subscribe((data) => {
        this.productInfoBulletinEmailList = data.emailList || [];
        this.loading = false;
      });
    }
  }
}

